const defaultVisibilityState: Record<string, boolean> = {
    id: false,
    name: true,
    email: true,
    phone: true,
    address: true,
};

export default defaultVisibilityState;
